import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import All from '../views/All.vue'
import * as firebase from 'firebase/app'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      auth: true,
    },
  },
  {
    path: '/all',
    name: 'All',
    component: All,
    meta: {
      auth: true,
    },
  },
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
]

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}

    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash

      // // specify offset of the element
      // if (to.hash === '#anchor2') {
      //   position.offset = { y: 100 }
      // }
      position.offset = { y: 100 }
      // bypass #1number check
      if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        window.scrollTo({
          top: document.querySelector(to.hash).offsetTop,
          behavior: 'smooth',
        })
        //return position
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return false
    }

    return new Promise((resolve) => {
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some((m) => m.meta.scrollToTop)) {
        // coords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0
        position.y = 0
      }
      resolve(position)
      // wait for the out transition to complete (if necessary)
      // this.app.$root.$once('triggerScroll', () => {
      //   // if the resolved position is falsy or an empty object,
      //   // will retain current scroll position.
      //   resolve(position)
      // })
    })
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    let isLogged = store.state.loggedIn
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // on reload if google says you are logged in, sync the store to reflect
        isLogged ? null : store.commit('setLogin', true)
        next()
      } else {
        next({
          path: '/',
        })
      }
    })
  } else {
    next()
  }
})

export default router
